import { Modal } from '@systemeio/ui'
import { actionItems } from 'modules/automation-rules/actions/constants/action-items'
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum'
import { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useAllowedActions } from '../hooks/use-allowed-actions'
import { AddIcon } from '@systemeio/ui'

interface AddActionModalProps {
  isReady: boolean
  onAddAction: (action: AutomationRuleActionsEnum) => void
}

const AddActionModal = ({ isReady, onAddAction }: AddActionModalProps) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)
  const allowedActions = useAllowedActions()
  return (
    <>
      <button
        disabled={!isReady}
        onClick={() => setOpened(true)}
        className={`group flex self-center rounded-full outline-hidden ${
          !isReady && 'pointer-events-none'
        }`}
      >
        <AddIcon
          className={`${
            !isReady && 'fill-fill-primary/70 animate-pulse'
          } main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary fill-fill-primary h-[30px] w-[30px]`}
        />
      </button>
      <Modal
        title={t('dashboard.automation_rule.edit.add_action')}
        opened={opened}
        onClose={() => setOpened(false)}
      >
        <div className={'flex flex-col gap-5 px-10'}>
          {actionItems
            .filter(el => allowedActions.includes(el.slug))
            .map((action, idx) => (
              <button
                onClick={() => {
                  onAddAction(action.slug)
                  setOpened(false)
                }}
                key={idx}
                className={`group flex w-full gap-3 text-left outline-hidden ${
                  idx !== 0 && 'border-text-secondary/30 border-t pt-5'
                }`}
              >
                <div
                  className={
                    '[&>svg]:main-transition-colors [&>svg]:group-hover:fill-brand-primary [&>svg]:group-focus-visible:fill-brand-primary [&>svg]:h-[40x] [&>svg]:w-[40px] w-[40px]'
                  }
                >
                  {action.icon}
                </div>
                <div className={'flex flex-col gap-1'}>
                  <span className={'text-text-primary text-[15px] font-bold'}>
                    {t(action.title)}
                  </span>
                  <span>{t(action.description)}</span>
                </div>
              </button>
            ))}
        </div>
      </Modal>
    </>
  )
}

export default AddActionModal
